<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <UCard
    class="gradient-texture"
    :ui="{ body: { base: 'flex-1' }, base: 'flex flex-col', footer: { base: '!p-0' } }"
  >
    <template #header>
      <div class="flex items-center justify-between">
        <div class="flex flex-col">
          <span class="flex items-center gap-2">
            <UIcon
              class="text-lg text-gray-500 md:text-xl dark:text-gray-400"
              :name="getIcon('apiToken')"
            />

            <h2 class="text-lg font-bold">
              {{ t('cardTitle') }}
            </h2>
          </span>
        </div>
      </div>
    </template>

    <div class="flex h-full flex-col justify-between gap-8">
      <ApiTokensBox
        class="h-full"
        :has-borders="false"
      />

      <div class="flex w-full items-center justify-center">
        <span class="text-sm text-gray-500">
          {{ t('cardDescription') }}
        </span>
      </div>
    </div>

    <template #footer>
      <DocsPageLink
        class="rounded-t-none"
        :description="t('description')"
        path="/api/authentication"
        :title="t('title')"
      />
    </template>
  </UCard>
</template>

<i18n lang="json">
{
  "en": {
    "cardDescription": "Tokens carry many privileges, so keep them secure!",
    "cardTitle": "API Tokens",
    "description": "Learn how to use your API tokens",
    "title": "Authentication"
  },
  "es": {
    "cardDescription": "Los tokens llevan muchos privilegios, así que manténgalos seguros!",
    "cardTitle": "Tokens API",
    "description": "Aprende a usar tus tokens API",
    "title": "Autenticación"
  },
  "fr": {
    "cardDescription": "Les tokens confèrent de nombreux privilèges, alors gardez-les en sécurité !",
    "cardTitle": "Tokens API",
    "description": "Apprenez à utiliser vos tokens API",
    "title": "Authentification"
  }
}
</i18n>
